import React, { useState, useEffect } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { getter } from "@progress/kendo-react-common";
import { loadProjectPlanGridData } from "../../../../handlers/ClientDetail/GridApiCall";
import { useSelector } from "react-redux";

import useReloadButton from "../../../../CustomHooks/useReloadButton";
import { useKendoGridHandlers } from "../../../../CustomHooks/useKendoGridHandlers";

const DATA_ITEM_KEY = "SEQ_NUM";
const SELECTED_FIELD = "selected";

const idGetter = getter(DATA_ITEM_KEY);

export const DEFAULT_GRID_INFO_CLIENT_TRAINING = {
  action: "LOADTRAININGS",
  className: "CLIENTDETAIL",
  pageSize: 20,
  currentPageNumber: 1,
  sortName: "TRAINING_DESCRIPTION",
  sortOrder: "desc",
  gridHeight: "300px",
};

const PAGER_SETTINGS = {
  info: true,
  type: "input",
  previousNext: true,
  pageSize: 4,
  refresh: true,
};

const KendoTrainingGrid = React.memo((props) => {
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [gridData, setGridData] = useState([]);
  const [total, setTotal] = useState(0);
  const [gridState, setGridState] = useState({
    pageNumber: DEFAULT_GRID_INFO_CLIENT_TRAINING.currentPageNumber,
    pageSize: DEFAULT_GRID_INFO_CLIENT_TRAINING.pageSize,
    sortName: DEFAULT_GRID_INFO_CLIENT_TRAINING.sortName,
    sortOrder: DEFAULT_GRID_INFO_CLIENT_TRAINING.sortOrder,
    sort: [
      {
        field: DEFAULT_GRID_INFO_CLIENT_TRAINING.sortName,
        dir:
          DEFAULT_GRID_INFO_CLIENT_TRAINING.sortOrder?.toLowerCase() || "asc",
      },
    ],
  });
  const [reloadToggle, setReloadToggle] = useState(false);

  const { HandleDataStateChange, HandlePageChange } =
    useKendoGridHandlers(setGridState);

  const [selectedState, setSelectedState] = React.useState();

  // UseEffect to load the grid data
  useEffect(() => {
    loadProjectPlanGridData(sharedData.currentClientId, gridState).then((response) => {
      if (response) {
        setGridData(response.rows);
        setTotal(response.total);
      }
    });
  }, [props, reloadToggle]); //gridState, reloadToggle

  useReloadButton(setReloadToggle);

  const SelectedContentLength = () => {
    const selectedText = window.getSelection().toString();
    return selectedText.length > 0;
  };

  const onSelectionChange = React.useCallback(
    (event) => {
      const check = SelectedContentLength();
      if (!check) {
        const newSelectedState = getSelectedState({
          event,
          selectedState,
          dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);
      }
    },
    [selectedState]
  );

  const ShowTrainingDetail = (data) => {
    props.AlterTrainingState({
      show: true,
      training: data.dataItem,
    });
  };

  const TrainingTypeField = (props) => (
    <td>
      <p
        style={{
          textAlign: "left",
          color: "#0b70b8",
          cursor: "pointer",
          margin: "0px",
        }}
        className="link"
        onClick={() => ShowTrainingDetail(props)}
      >
        {props.dataItem.TRAINING_TYPE}
      </p>
    </td>
  );

  const CellScheduleDate = (props) => (
    <td className="Comments30">
      <span className="textWrap">
        {props.dataItem.SCHEDULE_DATETIME.split(" ")[0]}
      </span>
    </td>
  );

  const TrainingStatusField = (props) => (
    <td>
      <p style={{ textAlign: "left", margin: "0px" }} className="link">
        {props.dataItem.TRAINING_STATUS != null
          ? props.dataItem.TRAINING_STATUS
          : "INPROCESS"}
      </p>
    </td>
  );

  const CellCreatedDate = (props) => (
    <td className="Comments30">
      <span className=" pl-4">{props.dataItem.ENTRY_DATE.split(" ")[0]}</span>
    </td>
  );

  return (
    <div>
      <Tooltip openDelay={100} position="right" anchorElement="target">
        <Grid
          style={{
            height: "calc(100vh - 300px)",
          }}
          scrollable="scrollable"
          total={total}
          skip={(gridState.pageNumber - 1) * gridState.pageSize}
          pageSize={gridState.pageSize}
          filterable={false}
          sortable={{
            mode: "single",
            allowUnsort: false,
          }}
          sort={gridState.sort}
          selectedField={SELECTED_FIELD}
          data={gridData.map((item) => ({
            ...item,
            [SELECTED_FIELD]: selectedState?.[idGetter(item)] || false,
          }))}
          selectable={{
            enabled: true,
            drag: false,
            cell: false,
            mode: "multiple",
          }}
          pageable={PAGER_SETTINGS}
          onPageChange={HandlePageChange}
          onDataStateChange={HandleDataStateChange}
          onSelectionChange={onSelectionChange}
        >
          <GridColumn
            title="Type"
            field="TRAINING_TYPE"
            cell={TrainingTypeField}
            width={140}
          />
          <GridColumn
            title="Description"
            field="TRAINING_DESCRIPTION"
            width={160}
          />
          <GridColumn
            title="Scehdule Date"
            field="SCHEDULE_DATETIME"
            cell={CellScheduleDate}
            width={150}
          />
          <GridColumn title="Trainner" field="TRAINNER" width={160} />
          <GridColumn
            title="Training Video Link"
            field="TRAINING_VIDEO_LINK"
            width={180}
          />
          <GridColumn title="Invitee" field="INVITEE" width={130} />
          <GridColumn title="Invitee Email" field="INVITEE_EMAIL" width={170} />
          <GridColumn
            title="Schedule Link"
            field="TRAINING_SCHEDULE_LINK"
            width={170}
          />
          <GridColumn
            title="Total Hours"
            field="TOTAL_HOURS"
            className="pl-5"
            width={170}
          />
          <GridColumn
            title="Status"
            field="TRAINING_STATUS"
            cell={TrainingStatusField}
            width={130}
          />
          <GridColumn title="Created By" field="ENTERED_BY" width={170} />
          <GridColumn
            title="Creation Date"
            field="ENTRY_DATE"
            cell={CellCreatedDate}
            width={140}
          />
        </Grid>
      </Tooltip>
    </div>
  );
});
export default KendoTrainingGrid;
